module.exports = __webpack_public_path__ + "static/media/icPlayerActive.5089cce3.svg";